import { gql } from '@apollo/client';

const CreateLead = gql`
  mutation CreateLead($name: String!, $email: String!, $phoneNumber: String!, $jobId: String!) {
    createLead(name: $name, email: $email, phoneNumber: $phoneNumber, jobId: $jobId) {
      code
      errors
      status
      token
    }
  }
`;

export { CreateLead };
